import { Component, input, type InputSignal } from "@angular/core";

/**
 * The Microsoft four-square mark.
 *
 * Kept out of `nav-icon` on purpose: every glyph in that set is a 1.6px
 * `currentColor` outline that inherits its colour from the surrounding text,
 * and this one is a fixed four-colour logo that must never be recoloured. Two
 * different contracts in one component is how a brand mark ends up rendered in
 * muted grey on a hover state.
 */
@Component({
  selector: "app-microsoft-mark",
  standalone: true,
  templateUrl: "./microsoft-mark.component.html",
  styleUrl: "./microsoft-mark.component.scss",
})
export class MicrosoftMarkComponent {

  public readonly size: InputSignal<number> = input<number>(18);
}
